/**
 * Canonical public label for an admin-deactivated (archived) account wherever
 * it still appears in user-facing history (group bubbles, announcement/forum
 * bylines, call history, transcripts). Shared by the frontend and any Lambda
 * that returns display names, so clients can never show a stale real name.
 *
 * NOT for self-service account deletion — that flow freezes "Deleted User"
 * onto the Users row (see delete-my-account) and is deliberately separate.
 */
export const DEACTIVATED_USER_LABEL = 'Deactivated user'

/** True for a Users.status / directory status meaning admin-deactivated. */
export function isInactiveUserStatus(status: string | null | undefined): boolean {
  return typeof status === 'string' && status.trim().toLowerCase() === 'inactive'
}
